<template>
	<div class="content">
		<div class="center flex-row">
			<div class="detail-box">
				<div class="device-box flex-row">
					<div class="device-img">
						<img :src="$imgUrl + info.pictureUrl" />
					</div>
					<div class="device-info">
						<p class="name">{{info.title}}</p>
						<div class="price-box flex-row">
							<span>价格</span>
							<span class="price">￥{{info.emergencyPrice}} /天</span>
							<span class="month-sale">月销量：{{ info.salesVolume }}</span>
						</div>
						<p class="tips">
							*价格说明<br>
							在勘查现场后，相关费用可能发生变化。
						</p>
						<div class="info">
							<div class="title">
								<p>设备信息</p>
							</div>
							<div class="info-intro flex-row">
								<div class="item"> <label>提供人姓名</label> <span>{{info.name}}</span> </div>
								<div class="item"> <label>设备类型</label> <span>{{info.typeName}}</span> </div>
								<div class="item"> <label>设备容量</label> <span>{{info.volume}}</span> </div>
								<div class="item"> <label>设备地点</label>
									<span>{{(info.provinceName + info.cityName + info.countyName) || '未知'}}</span>
								</div>
								<div class="item"> <label>输出电压</label> <span>{{info.voltage}}</span> </div>
							</div>
						</div>
						<div class="bot flex-row justify-between">
							<div class="btns flex-row" v-if="changeEq == 0">
								<button class="apply" @click="applyHandle">申请</button>
								<button class="service" @click="openCustomerServer">在线留言</button>
							</div>
							<div class="btns flex-row" v-if="changeEq != 0">
								<button class="apply" @click="saveChangeOrderEq">确定</button>
							</div>
							<div v-if="!info.isdTrue" class="collect flex-row" @click="addEquipment">
								<img src="../../assets/image/collect.png" />
								<span>加入列表</span>
							</div>
							<div v-if="info.isdTrue" class="collect flex-row" @click="deladdEquipment">
								<img src="../../assets/image/collected.png" />
								<span>已加入</span>
							</div>
						</div>
					</div>
				</div>

				<div class="intro-box">
					<div class="title-box flex-row justify-between">
						<div class="nav-box">
							<span :class="{active: activeNum==index}" v-for="(item,index) in navList"
								@click="activeNum=index">{{item}}</span>
						</div>
						<div class="right flex-row">
							<span
								style="font-size: 14px;color: #8B8B8B;margin-right: 10px;">{{info.fraction == 0 ? '暂无评分' : '综合评分'}}</span>
							<el-rate v-if="info.fraction != 0" v-model="info.fraction > 5 ? 5 : info.fraction" :max="5"
								disabled show-score text-color="#ff9900" score-template="{value}">
							</el-rate>
						</div>
					</div>
					<div class="device-intro flex-row" v-if="activeNum == 0"
						style="display: flex;flex-direction: column;">
						<span>{{info.conment}}</span>
						<el-image v-if="info.conmentUrl" :src="$imgUrl + info.conmentUrl"
							style="width: 150px;height: 150px;margin-top: 20px;"
							:preview-src-list="[$imgUrl + info.conmentUrl]" />
					</div>
					<div class="device-intro flex-row" v-if="activeNum == 1"
						style="display: flex;flex-direction: column;">
						<span>{{info.deviceReported}}</span>
						<el-image v-if="info.deviceReportedUrl" :src="$imgUrl + info.deviceReportedUrl"
							style="width: 150px;height: 150px;margin-top: 20px;"
							:preview-src-list="[$imgUrl + info.deviceReportedUrl]" />
					</div>
					<div class="device-intro flex-row" v-if="activeNum == 2">
						<el-image v-if="info.deviceCertificate" :src="$imgUrl + info.deviceCertificate" alt=""
							style="width: 120px;height: 150px;"
							:preview-src-list="[$imgUrl + info.deviceCertificate]" />
					</div>
					<div class="device-intro flex-row" v-if="activeNum == 3">
						<el-image v-if="info.scheme" :src="$imgUrl + info.scheme" alt=""
							style="width: 120px;height: 150px;" :preview-src-list="[$imgUrl + info.scheme]" />
					</div>
					<div class="coment-intro flex-row" v-if="activeNum == 4">
						<CommentList :commentList="info.commentDtoList"></CommentList>
					</div>
				</div>
			</div>
			<div class="recommend-box">
				<div class="recommend">
					<p class="title">相似设备推荐</p>
					<div class="rec-list">
						<div v-for="(item,i) in eqList" :key="i" class="rec-item" @click="changeDetail(item)">
							<RelatedDevice :detail="item"></RelatedDevice>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import RelatedDevice from '@/components/ordinary/RelatedDevice.vue'
	import CommentList from '@/components/commentList.vue'
	import {
		equipmentDetailApi,
		equipmentListApi,
		addEquipmentApi,
		delEquipmentApi
	} from '../../http/api/ordinary.js'
	import {
		updateOrder,
		updateOrderEq
	} from '../../http/factory/add-eme.js'
	export default {
		components: {
			RelatedDevice,
			CommentList
		},
		data() {
			return {
				activeNum: 0,
				navList: ['设备详情', '设备报告', '设备证书', '保电方案', '用户评价'],
				info: {},
				eqList: [],
				detailId: null,
				changeEq: '0'
			};
		},
		created() {
			this.detailId = this.$route.query.id
			this.changeEq = this.$route.query.changeEq
			this.getDetail()
			this.getEquipamentList()

		},
		methods: {
			addEquipment() {
				addEquipmentApi({
					goodId: this.info.id
				}).then(res => {
					this.$message({
						message: '当前设备已加入设备列表',
						type: 'success'
					});
					this.getDetail()
				})
			},
			deladdEquipment() {
				delEquipmentApi({
					goodId: this.info.id
				}).then(res => {
					this.$message({
						message: '当前设备已从设备列表中移除',
						type: 'success'
					});
					this.getDetail()
				})
			},
			saveChangeOrderEq() {
				updateOrderEq({
					id: this.changeEq,
					equipmentId: this.info.id
				}).then(res => {
					this.$message({
						message: '设备修改成功',
						type: 'success'
					});
					this.$router.push({
						path: '/orderDetail/powerDetail',
						query: {
							id: this.changeEq
						}
					})
				})
			},
			openCustomerServer() {
				this.$router.push({
					path: '/service',
					query: {
						contactType: 1,
						contactId: this.info.customerId
					}
				})
			},
			getDetail() {
				equipmentDetailApi({
					id: this.detailId
				}).then(res => {
					this.info = res
				})
			},
			getEquipamentList() {
				equipmentListApi({
					serviceType: 1,
					pageSize: 6
				}).then(res => {
					this.eqList = res.rows
				})
			},
			applyHandle() {
				this.$router.push({
					path: '/ordinaryUser/emergencyApply',
					query: {
						id: this.$route.query.id
					}
				})
			},
			changeDetail(item) {
				this.detailId = item.id
				this.$route.query.id = item.id
				this.getDetail()
			}
		}
	}
</script>

<style scoped lang="less">
	.content {
		font-size: .14rem;
		background: #F5F5F5;

		.center {
			width: 16.88rem;
			margin: 0 auto;
			padding: 0.2rem 0;

			button {
				outline: none;
				cursor: pointer;
			}
		}

		.detail-box {
			flex: 1;
			background: #FFFFFF;
			border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
			margin-right: .21rem;
			padding: .25rem .3rem;

			.device-box {
				.device-img {
					width: 2.96rem;
					height: 2.96rem;
					border-radius: 0.06rem;
					margin-right: .2rem;

					img {
						width: 100%;
						height: 100%;
						border-radius: 0.06rem;
					}
				}

				.device-info {
					flex: 1;

					.name {
						font-size: .2rem;
						color: #333333;
						line-height: .23rem;
						font-weight: 500;
					}

					.price-box {
						margin-top: .22rem;
						font-size: .14rem;
						color: #000000;
						line-height: .2rem;
						align-items: center;
						position: relative;

						.price {
							color: #FF4141;
							margin-left: .1rem;
						}

						.month-sale {
							color: #333333;
							margin-left: .38rem;
							position: relative;

							&::after {
								content: '';
								width: 1px;
								height: .08rem;
								border-left: 1px solid #E3E3E3;
								position: absolute;
								left: -0.19rem;
								top: 0.07rem;
							}
						}
					}

					.tips {
						font-size: .13rem;
						color: #8F8F8F;
						line-height: .33rem;
						margin-top: .1rem;
					}

					.info {
						width: 100%;
						border-radius: .06rem;
						opacity: 1;
						border: 1px solid #F2F2F2;
						margin-top: .16rem;

						.title {
							height: .44rem;
							background: #FFF3EC;
							padding: 0 .24rem;

							p {
								font-size: .16rem;
								color: #000000;
								line-height: .44rem;
								position: relative;

								&::after {
									content: '';
									width: .04rem;
									height: .14rem;
									background: #FF5400;
									position: absolute;
									top: .14rem;
									left: -0.1rem;
								}
							}
						}

						.info-intro {
							flex-wrap: wrap;
							padding: .1rem 0;
							background-color: #FFFDFC;

							.item {
								width: calc(50% - .4rem);
								line-height: 0;
								padding: .15rem .2rem;

								label {
									display: inline-block;
									min-width: .9rem;
									font-size: .14rem;
									line-height: .24rem;
									color: #AAAAAA;
									margin-right: .2rem;
									text-align: right;
								}

								span {
									font-size: .14rem;
									line-height: .24rem;
									color: #333333;
								}
							}
						}
					}

					.bot {
						margin-top: .24rem;

						.btns {
							.apply {
								width: 1.07rem;
								height: .42rem;
								background: #FA6600;
								border-radius: .06rem;
								font-size: .14rem;
								color: #FFFFFF;
								line-height: .42rem;
								text-align: center;
								border: none;
							}

							.service {
								width: 1.07rem;
								height: .42rem;
								background: #FFFFFF;
								border-radius: .06rem;
								border: 1px solid #FA6600;
								font-size: .14rem;
								color: #FA6600;
								line-height: .42rem;
								text-align: center;
								margin-left: .2rem;
							}
						}

						.collect {
							display: flex;
							align-items: center;
							cursor: pointer;

							img {
								width: 22px;
								height: 22px;
								margin-right: 10px;
							}

							span {
								font-size: .14rem;
								color: #818181;
								line-height: .4rem;
							}
						}
					}
				}
			}

			.intro-box {
				margin-top: .63rem;
				background: #FFFFFF;
				border-radius: .06rem;
				border: 1px solid #E9E9E9;

				.title-box {
					min-height: .52rem;
					background: #F4F4F4;
					border-radius: .05rem .05rem 0px 0px;

					.nav-box {
						padding: 0 .17rem;

						span {
							display: inline-block;
							margin: 0 .25rem;
							font-size: .14rem;
							line-height: .52rem;
							color: #000000;
							position: relative;
							cursor: pointer;

							&.active {
								color: #FA6600;
							}

							&.active::after {
								content: '';
								width: 100%;
								height: .04rem;
								background: #FA6600;
								border-radius: .05rem;
								position: absolute;
								left: 0;
								bottom: 0;
							}
						}
					}

					.right {
						height: .52rem;
						padding: 0 .2rem;
						border-top: 1px dashed #F3F3F3;
						align-items: center;

						.card-text_3 {
							font-size: .13rem;
							font-family: PingFang SC-Regular, PingFang SC;
							color: #8B8B8B;
							line-height: .18rem;
							margin-right: .09rem;
							white-space: nowrap;
						}

						.xingxing {
							width: .15rem;
							height: .15rem;
							margin-right: .06rem;
							background: url('../../assets/image/star_2.png') no-repeat;
							background-size: 100% 100%;

							&.active {
								background: url('../../assets/image/star_1.png') no-repeat;
								background-size: 100% 100%;
							}
						}

						.text-score {
							font-size: .13rem;
							font-family: PingFang SC-Regular, PingFang SC;
							color: #FF7E36;
							line-height: .18rem;
							margin-left: .04rem;
						}
					}
				}

				.device-intro {
					flex-wrap: wrap;
					padding: .3rem .2rem;

					img {
						max-width: 100%;
					}
				}
			}

			.coment-intro {
				padding: 20px;
				min-height: 100px;
				max-height: 400px;
				overflow-y: auto;
			}
		}

		.recommend-box {
			width: 4.87rem;

			.recommend {
				padding: 0.2rem 0.27rem;
				background: #FFFFFF;
				border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;

				.title {
					font-size: 0.14rem;
					color: #000000;
					line-height: 1;
					padding-bottom: 0.06rem;
				}

				.rec-list {
					.rec-item {
						cursor: pointer;
						padding: .24rem 0;
						border-bottom: 1px solid #EFEFEF;
					}

					.rec-item:last-child {
						border-bottom: none;
					}
				}
			}
		}
	}
</style>
